<template>
  <div class="col-12 confirm-content">
    <p>{{$t('home.widgets.list.lostcom_confirm_content')}}</p>
    <p>
      {{$t('home.widgets.list.lostcom_confirm_content_profile_text')}}
      <button class="underline btn-unstyled" @click="handleProfileSetting">
        {{$t('home.widgets.list.lostcom_confirm_content_profile_link')}}
      </button>
    </p>
  </div>
</template>

<script>
export default {
  name: "LostcomConfirmContent",
  computed: {
    profile_id: function() {
      return this.$attrs.profile_id;
    }
  },
  methods: {
    handleProfileSetting: function() {
      window.Vfc.$refs.confirm.hide()
      this.$router.push({name: 'ProfilesShow', params: {id: this.$attrs.profile_id}})
    }
  }
}
</script>